import * as Types from '../constants/Types';

export const getAllHotels = () => ({ type: Types.HOTEL_All_ACTION });
export const setAllHotels = (hotels) => ({ type: Types.HOTEL_All_SUCCESS, hotels });

export const getListHotels = (filters) => ({ type: Types.HOTEL_LIST_ACTION, filters });
export const setListHotels = (data) => ({ type: Types.HOTEL_LIST_SUCCESS, hotels: data.hotels, pageIndex: data.pageIndex, pageSize: data.pageSize, totalCount: data.totalCount });

export const getHotelDetail = (id) => ({ type: Types.HOTEL_DETAIL_ACTION, id });
export const setHotelDetail = (hotel) => ({ type: Types.HOTEL_DETAIL_SUCCESS, hotel });
export const updateHotelDetail = (hotel) => ({ type: Types.HOTEL_DETAIL_UPDATE_ACTION, hotel });
export const createHotelDetail = (hotel, callbacks) => ({ type: Types.HOTEL_DETAIL_CREATE_ACTION, hotel, callbacks });

export const createHotelTranslate = (hotel) => ({type: Types.HOTEL_CREATE_TRANSLATE_ACTION, hotel});
export const updateHotelTranslate = (hotel) => ({type: Types.HOTEL_UPDATE_TRANSLATE_ACTION, hotel});
export const deleteHotelTranslate = (hotel, refreshParams) => ({type: Types.HOTEL_DELETE_TRANSLATE_ACTION, hotel, refreshParams});

export const getTagGroupDetailSku = (id) => ({ type: Types.HOTEL_TAG_GROUP_DETAIL_SKU_ACTION, id });
export const setTagGroupDetailSku = (data) => ({ type: Types.HOTEL_TAG_GROUP_DETAIL_SKU_SUCCESS, tagsGroupDetail: data });

export const updateTagGroupDetailSkuActive = (data, id) => ({ type: Types.HOTEL_TAG_GROUP_DETAIL_SKU_ACTIVE_ACTION, data, id });

export const getAllHotelActive = (params) => ({type: Types.HOTEL_ALL_ACTIVE_ACTION, params});
export const setAllHotelActive = (data) => ({ type: Types.HOTEL_ALL_ACTIVE_SUCCESS, hotelActive: data })

export const clearCache = (value) => ({ type: Types.CLEAR_CACHE_ACTION, value });

export const getListRateCompare = (filters) => ({ type: Types.RATE_LIST_COMPARE_ACTION, filters });
export const setListRateCompare = (data) => ({ type: Types.RATE_LIST_COMPARE_SUCCESS, rateCompareList: data });
export const createRateCompare = (data) => ({ type: Types.RATE_LIST_COMPARE_CREATE_ACTION, data });
export const updateRateCompare = (data) => ({ type: Types.RATE_LIST_COMPARE_UPDATE_ACTION, data });
export const deleteRateCompare = (data) => ({ type: Types.RATE_LIST_COMPARE_DELETE_ACTION, data });
